import { employee } from '@/endpoint.flexigo';
import Repository from './repository';

const client = new Repository();

export default {
  async getSurveryQuestion(questionId) {
    const r = await client.get(employee.surveyQuestion.replace(':questionId', questionId));
    return r;
  },
  async sendSurveryAnswers(payload) {
    const r = await client.post(employee.surveyAnswer, payload);
    return r;
  },
  async setHomeAddress(payload) {
    const r = await client.post(employee.homeAddress, payload);
    return r;
  },
  async fetchNearbyStations() {
    const r = await client.get(employee.nearbyStation);
    return r;
  },
  async getRoutePath() {
    const r = await client.get(employee.routePath);
    return r;
  },
  async updateStation(id, payload) {
    const r = await client.post(employee.stationUpdate.replace(':id', id), payload);
    return r;
  },
  async updatePassword(id, payload) {
    const r = await client.post(employee.activate.replace(':id', id), payload);
    return r;
  },
  async updatePersonnelCampus(destinationId) {
    const r = await client.post(employee.updateCampus, destinationId);
    return r;
  },
  async updateAgreement(payload) {
    const r = await client.post(employee.updateAgreement, payload);
    return r;
  },
  async getNotifications(payload) {
    const r = await client.get(employee.notifications, payload);
    return r;
  },
  async deleteNotifications(payload) {
    const r = await client.post(employee.deleteNotifications, payload);
    return r;
  },
};
